import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const LIFESTYLE_QUERY_KEY = "lifestyleData";

export const useLifeStyleQuery = (patientUserId) => {
  return useQuery({
    queryKey: [LIFESTYLE_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "hrlifestyleapi",
        path: "/" + patientUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    staleTime: Infinity,
    enabled: !!patientUserId,
    placeholderData: [],
  });
};
